// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from '@hey-api/client-fetch';
import type { GetStatusData, GetWinstonApiSchemaData, GetReadyzData, GetReadyzResponse, PostWinstonProjectsByProjectIdAssessmentsData, PostWinstonProjectsByProjectIdAssessmentsResponse, PostWinstonProjectsByProjectIdAssessmentsError, GetWinstonProjectsByProjectIdAssessmentsData, GetWinstonProjectsByProjectIdAssessmentsResponse, GetWinstonProjectsByProjectIdAssessmentsError, GetWinstonProjectsByProjectIdAssessmentsByPillarData, GetWinstonProjectsByProjectIdAssessmentsByPillarResponse, GetWinstonProjectsByProjectIdAssessmentsByPillarError, PostWinstonContentfulData, GetWinstonCountryProfilesData, GetWinstonCountryProfilesResponse, GetWinstonCountryProfilesError, GetWinstonEarlyStageProjectsFiltersData, GetWinstonEarlyStageProjectsFiltersResponse, GetWinstonEarlyStageProjectsFiltersError, PostWinstonEarlyStageProjectsData, PostWinstonEarlyStageProjectsResponse, PostWinstonEarlyStageProjectsError, GetWinstonEarlyStageProjectsByIdData, GetWinstonEarlyStageProjectsByIdResponse, GetWinstonEarlyStageProjectsByIdError, GetWinstonEdhBoundariesBySylveraIdData, GetWinstonEdhBoundariesBySylveraIdResponse, GetWinstonEdhBoundariesBySylveraIdError, GetWinstonEdhProjectDatesBySylveraIdData, GetWinstonEdhProjectDatesBySylveraIdResponse, GetWinstonEdhProjectDatesBySylveraIdError, GetWinstonOrganisationsByIdData, GetWinstonOrganisationsByIdResponse, GetWinstonOrganisationsByIdError, PatchWinstonOrganisationsByIdData, PatchWinstonOrganisationsByIdResponse, PatchWinstonOrganisationsByIdError, GetWinstonPreIssuanceBoxTokenData, GetWinstonPreIssuanceBoxTokenResponse, GetWinstonPreIssuanceBoxTokenError, PostWinstonProjectsFiltersData, PostWinstonProjectsFiltersResponse, PostWinstonProjectsFiltersError, PostWinstonProjectsData, PostWinstonProjectsResponse, PostWinstonProjectsError, GetWinstonProjectsByIdData, GetWinstonProjectsByIdResponse, GetWinstonProjectsByIdError, GetWinstonProjectsShortlistData, GetWinstonProjectsShortlistResponse, GetWinstonProjectsShortlistError, PatchWinstonProjectsShortlistData, PatchWinstonProjectsShortlistResponse, PatchWinstonProjectsShortlistError, GetWinstonUsersMeData, GetWinstonUsersMeResponse, GetWinstonUsersMeError, GetWinstonPlansData, GetWinstonPlansResponse, GetWinstonPlansError } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
};

export const getStatus = <ThrowOnError extends boolean = false>(options?: Options<GetStatusData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/status',
        ...options
    });
};

export const getWinstonApiSchema = <ThrowOnError extends boolean = false>(options?: Options<GetWinstonApiSchemaData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/winston/api-schema',
        ...options
    });
};

/**
 * Check if the service is ready to accept requests
 */
export const getReadyz = <ThrowOnError extends boolean = false>(options?: Options<GetReadyzData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetReadyzResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/readyz',
        ...options
    });
};

/**
 * Submit a project assessment
 */
export const postWinstonProjectsByProjectIdAssessments = <ThrowOnError extends boolean = false>(options: Options<PostWinstonProjectsByProjectIdAssessmentsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostWinstonProjectsByProjectIdAssessmentsResponse, PostWinstonProjectsByProjectIdAssessmentsError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/winston/projects/{project_id}/assessments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get available assessments for a project
 */
export const getWinstonProjectsByProjectIdAssessments = <ThrowOnError extends boolean = false>(options: Options<GetWinstonProjectsByProjectIdAssessmentsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetWinstonProjectsByProjectIdAssessmentsResponse, GetWinstonProjectsByProjectIdAssessmentsError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/winston/projects/{projectId}/assessments',
        ...options
    });
};

/**
 * Returns the latest assessment result for a particular pillar for a project
 */
export const getWinstonProjectsByProjectIdAssessmentsByPillar = <ThrowOnError extends boolean = false>(options: Options<GetWinstonProjectsByProjectIdAssessmentsByPillarData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetWinstonProjectsByProjectIdAssessmentsByPillarResponse, GetWinstonProjectsByProjectIdAssessmentsByPillarError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/winston/projects/{projectId}/assessments/{pillar}',
        ...options
    });
};

export const postWinstonContentful = <ThrowOnError extends boolean = false>(options?: Options<PostWinstonContentfulData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/winston/contentful',
        ...options
    });
};

export const getWinstonCountryProfiles = <ThrowOnError extends boolean = false>(options?: Options<GetWinstonCountryProfilesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetWinstonCountryProfilesResponse, GetWinstonCountryProfilesError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/winston/country-profiles',
        ...options
    });
};

/**
 * Get projects filters items
 * Get projects filters items to be displayed by the filters for early stage projects.
 */
export const getWinstonEarlyStageProjectsFilters = <ThrowOnError extends boolean = false>(options?: Options<GetWinstonEarlyStageProjectsFiltersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetWinstonEarlyStageProjectsFiltersResponse, GetWinstonEarlyStageProjectsFiltersError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/winston/early-stage-projects-filters',
        ...options
    });
};

/**
 * List early stage projects
 */
export const postWinstonEarlyStageProjects = <ThrowOnError extends boolean = false>(options?: Options<PostWinstonEarlyStageProjectsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostWinstonEarlyStageProjectsResponse, PostWinstonEarlyStageProjectsError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/winston/early-stage-projects',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Early stage projects details
 */
export const getWinstonEarlyStageProjectsById = <ThrowOnError extends boolean = false>(options: Options<GetWinstonEarlyStageProjectsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetWinstonEarlyStageProjectsByIdResponse, GetWinstonEarlyStageProjectsByIdError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/winston/early-stage-projects/{id}',
        ...options
    });
};

export const getWinstonEdhBoundariesBySylveraId = <ThrowOnError extends boolean = false>(options: Options<GetWinstonEdhBoundariesBySylveraIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetWinstonEdhBoundariesBySylveraIdResponse, GetWinstonEdhBoundariesBySylveraIdError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/winston/edh/boundaries/{sylveraId}',
        ...options
    });
};

export const getWinstonEdhProjectDatesBySylveraId = <ThrowOnError extends boolean = false>(options: Options<GetWinstonEdhProjectDatesBySylveraIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetWinstonEdhProjectDatesBySylveraIdResponse, GetWinstonEdhProjectDatesBySylveraIdError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/winston/edh/project-dates/{sylveraId}',
        ...options
    });
};

/**
 * Get an organisation including its plan ID
 */
export const getWinstonOrganisationsById = <ThrowOnError extends boolean = false>(options: Options<GetWinstonOrganisationsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetWinstonOrganisationsByIdResponse, GetWinstonOrganisationsByIdError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/winston/organisations/{id}',
        ...options
    });
};

/**
 * Update an organisation including its plan ID
 */
export const patchWinstonOrganisationsById = <ThrowOnError extends boolean = false>(options: Options<PatchWinstonOrganisationsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<PatchWinstonOrganisationsByIdResponse, PatchWinstonOrganisationsByIdError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/winston/organisations/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get Box API token for pre-issuance folder display
 * This endpoint returns a Box API token to be used to display the pre-issuance folder in the webapp.
 */
export const getWinstonPreIssuanceBoxToken = <ThrowOnError extends boolean = false>(options?: Options<GetWinstonPreIssuanceBoxTokenData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetWinstonPreIssuanceBoxTokenResponse, GetWinstonPreIssuanceBoxTokenError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/winston/pre-issuance/box-token',
        ...options
    });
};

/**
 * Get projects filters items
 * Get projects filters items to be displayed by the filters. The provided lists are partial and limited to a subset. You may use a filter parameter to get a paginated list of items.
 */
export const postWinstonProjectsFilters = <ThrowOnError extends boolean = false>(options?: Options<PostWinstonProjectsFiltersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostWinstonProjectsFiltersResponse, PostWinstonProjectsFiltersError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/winston/projects-filters',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * List projects
 */
export const postWinstonProjects = <ThrowOnError extends boolean = false>(options?: Options<PostWinstonProjectsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<PostWinstonProjectsResponse, PostWinstonProjectsError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/winston/projects',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get project details
 */
export const getWinstonProjectsById = <ThrowOnError extends boolean = false>(options: Options<GetWinstonProjectsByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetWinstonProjectsByIdResponse, GetWinstonProjectsByIdError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/winston/projects/{id}',
        ...options
    });
};

/**
 * Fetches all shortlisted projects ids for the authenticated user
 */
export const getWinstonProjectsShortlist = <ThrowOnError extends boolean = false>(options?: Options<GetWinstonProjectsShortlistData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetWinstonProjectsShortlistResponse, GetWinstonProjectsShortlistError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/winston/projects-shortlist',
        ...options
    });
};

/**
 * Adds or Removes a project id from the shortlist for the authenticated user
 */
export const patchWinstonProjectsShortlist = <ThrowOnError extends boolean = false>(options: Options<PatchWinstonProjectsShortlistData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<PatchWinstonProjectsShortlistResponse, PatchWinstonProjectsShortlistError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/winston/projects-shortlist',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const getWinstonUsersMe = <ThrowOnError extends boolean = false>(options?: Options<GetWinstonUsersMeData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetWinstonUsersMeResponse, GetWinstonUsersMeError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/winston/users/me',
        ...options
    });
};

export const getWinstonPlans = <ThrowOnError extends boolean = false>(options?: Options<GetWinstonPlansData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetWinstonPlansResponse, GetWinstonPlansError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/winston/plans',
        ...options
    });
};